import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Articles from './views/Articles.vue'
import Login from './views/Login.vue'
import ApiConnector from "@/logic/connector/ApiConnector";
import TodayView from './views/TodayView.vue'

Vue.use(Router)

let router =  new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Articles,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/today',
      name: 'today',
      component: TodayView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/articles',
      name: 'articles',
      component: Articles,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});

let apiConnector = new ApiConnector();

router.beforeEach((to,from,next) => {
  if(to.matched.some(record => (record.meta.requiresAuth))) {
      if(apiConnector.isTokenExpired()) {
          next({
              path: '/login',
              params: { nextUrl: to.fullPath }
          })
      } else {
          next()
      }
  } else {
      next()
  }
})

export default router
